exports.install = function(Vue, options) {
    var messageShow = ''
    Vue.prototype.$handleMessageText = function(checkMessage) {
      let starIndex = 0
      messageShow = ''
      while (starIndex < checkMessage.length) {
        const text = checkMessage.substring(starIndex, checkMessage.length)
        starIndex = parseInt(starIndex) + parseInt(this.$handleLink(text))
      }

      messageShow = messageShow.replace(/([\w\.\-\pL]+@\w+\.\w+)/g, '<a class="chatLink chatLink-url" href=mailto:$1>$1</a>')

      this.$handleBR()
      return messageShow
    }
    Vue.prototype.$handleLink = function(text) {
      let position = 0
      const textStartPosition = text.indexOf('http')
      // console.log('字串長度 : ' + text.length)
  
      if (textStartPosition !== -1) {
        const textStart = text.substring(0, text.indexOf('http'))
        let textEnd = text.substring(text.indexOf('http'))
        const textData = textEnd.split(' ')
        let textEndPosition = 0
        if (textData.length < 2) {
          // 後面全都是網址 || 後面沒了
          textEnd = ''
          textEndPosition = text.length
        } else {
          // 表示後面還有其他空白鍵，但第一段一定是網址
          textEndPosition = textStartPosition + textData[0].toString().length
          textEnd = text.substring(textEndPosition, text.length)
        }
        // console.log('網址後的字串位置 : ' + textEndPosition)
        const textMiddle = textData[0].toString()
        text = textStart +
              '<a href="' +
              textMiddle +
              '" class="chatLink chatLink-url" target="_blank" rel="noopener noreferrer">' +
              textMiddle +
              '</a>'
        messageShow = messageShow + text
        position = textEndPosition
      } else {
        position = text.length
        messageShow = messageShow + text
      }
      // console.log('處理後的訊息 : ' + messageShow)
      // console.log('要回傳的 position : ' + position )
      return position
    }
  
    Vue.prototype.$handleEmail = function(text) {
    let position = 0
    // console.log('處理 email 的字串 : ' + text)
    // console.log('字串長度 : ' + text.length)
    let textStartPosition = text.indexOf('[email]')
    // console.log('20191029 textStartPosition : ' + textStartPosition)
    if (textStartPosition !== -1) {
        textStartPosition = textStartPosition + '[email]'.length
        // 第一節字串
        const textStart = text.substring(0, text.indexOf('[email]') + '[email]'.length)
        // console.log('第一節字串 : ' + textStart)
        // console.log('第一節字串結束位置 : ' + textStartPosition)
        // 之後所有字元
        let textEnd = text.substring(text.indexOf('[email]') + '[email]'.length)
        // console.log('之後所有字元 : ' + textEnd)
        const textData = textEnd.split('[email]')
        // console.log('空白分隔陣列 : ' )
        // console.log(textData)
        // console.log('陣列數量 : ' + textData.length)
        let textEndPosition = 0
        if (textData.length < 2) {
        // 後面全都是信箱 || 後面沒了
        textEnd = ''
        textEndPosition = text.length
        } else {
        // 表示後面還有其他 [email]，但第一段一定是信箱
        textEndPosition = textStartPosition + textData[0].toString().length + '[email]'.length
        textEnd = text.substring(textEndPosition, text.length)
        }
        // console.log('email 後的字串位置 : ' + textEndPosition)
        const textMiddle = textData[0].toString()
        // console.log('textStart : ' + textStart)
        // console.log('textMiddle : ' + textMiddle)
        // console.log('textEnd : ' + textEnd)
        text = textStart +
        '<a class="chatLink chatLink-url" href="mailto:' +
        textMiddle +
        '" ' +
        'target="_blank">' +
        textMiddle +
        '</a>'
        // + textEnd;
        // <a v-if="b.actionType == 'email'" :href=b.title target="_blank">{{ b.title }}</a>
        messageShow = messageShow + text
        // messageShow = text
        position = textEndPosition
    } else {
        position = messageShow + text.length
        // messageShow = text
        messageShow = messageShow + text
    }
    messageShow = messageShow.replace('[email]', '')
    // console.log('處理後的訊息 : ' + messageShow)
    // console.log('要回傳的 position : ' + position )
    return position
    }
    Vue.prototype.$handleBR = function() {
      // console.log('handleBR 處理前的訊息 : ' + messageShow)
      messageShow = messageShow.replace(/\n/g, '<BR>')
      // console.log('handleBR 處理後的訊息 : ' + messageShow)
    }
    Vue.prototype.$text2 = function() {
      // 全域性函式2
      // alert('執行成功2')
    }
  }
  


// WEBPACK FOOTER //
// ./src/global_function.js